// Tytuł karty przeglądarki zależnie od miejsca w aplikacji.
// Zwraca klucz tłumaczenia sekcji (pageTitle.*) i nazwę aplikacji;
// null = domyślny tytuł z public/index.html (strona główna, nieznane adresy).

export const DEFAULT_TITLE = 'MyKart.pl – Aplikacja dla kartingowców | Czasy, ranking, znajomi';

const MYKART = {
  aktualnosci: 'news',
  tablica: 'dashboard',
  ranking: 'ranking',
  kartometr: 'kartometr',
  osiagniecia: 'achievements',
  ramki: 'frames',
  'poziomy-xp': 'xpLevels',
  znajomi: 'friends',
  pro: 'pro',
  ustawienia: 'settings',
  profil: 'settings',
  uzytkownik: 'driverProfile',
  post: 'post',
  weryfikacja: 'verification',
  regulamin: 'terms',
  'polityka-prywatnosci': 'privacy',
  kontakt: 'contact',
  'o-projekcie': 'about',
  'dla-kartingowcow': 'forDrivers',
  'mpanel-admin-9x': 'admin',
};

const KARTLIFE = {
  garaz: 'garage',
  liga: 'league',
  trening: 'training',
  druzyna: 'team',
  bazarek: 'bazaar',
  rankingi: 'rankings',
  sezon: 'season',
  prestiz: 'prestige',
  poczta: 'mail',
  sklep: 'shop',
  osiagniecia: 'achievements',
  ustawienia: 'settings',
  wiecej: 'more',
  gracz: 'player',
};

export function pageTitleParts(pathname = '/') {
  const [first, second] = pathname.split('/').filter(Boolean).map(part => part.toLowerCase());
  if (first === 'kartlife') {
    return { app: 'KartLife', section: second ? KARTLIFE[second] || null : null };
  }
  const section = first ? MYKART[first] : null;
  return section ? { app: 'MyKart', section } : null;
}

// Licznik „(3)" przed tytułem — KartLife zgłasza tu, ile rzeczy czeka na gracza.
let titleBadge = 0;
const badgeListeners = new Set();
export const getTitleBadge = () => titleBadge;
export function subscribeTitleBadge(listener) {
  badgeListeners.add(listener);
  return () => badgeListeners.delete(listener);
}
export function setTitleBadge(count) {
  const next = Math.max(0, Math.floor(count) || 0);
  if (next === titleBadge) return;
  titleBadge = next;
  badgeListeners.forEach(listener => listener());
}

export function buildPageTitle(pathname, t, badge = 0) {
  const parts = pageTitleParts(pathname);
  if (!parts) return DEFAULT_TITLE;
  const title = parts.section ? `${t(`pageTitle.${parts.section}`)} · ${parts.app}` : parts.app;
  return parts.app === 'KartLife' && badge > 0 ? `(${badge > 99 ? '99+' : badge}) ${title}` : title;
}
